import _extends from 'babel-runtime/helpers/extends';

import { priority } from '@/common/material-metadata';

export default {
  name: 'PrioritySelector',

  componentName: 'PrioritySelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        placeholder: '请选择优先级',
        clearable: true,
        disabled: false,
        options: priority
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  }
};